
import { Component, mixins } from 'nuxt-property-decorator';
import {
  BannerBlockModel,
  contentBlockImageSizeModifiersMap,
  contentBlockTextHorizontalAlignmentModifiersMap,
} from 'fourwaves-shared';
import { RawHtml } from 'fourwaves-shared/components';
import ContentBlockMixin from '../ContentBlockMixin';
import ContentBlockButton from './ContentBlockButton.vue';

@Component({
  components: {
    RawHtml,
    ContentBlockButton,
  },
})
export default class BannerBlock extends mixins(ContentBlockMixin<BannerBlockModel>) {
  get imageSrc(): string {
    const src: string = this.newData.image.originalUrl[this.$i18n.locale];
    return src.trim() ? `${src}?w=2000&fit=max&auto=format` : '/images/page-builder/banner-block-default.webp';
  }

  get imageAlt(): string {
    return this.newData.image.altText[this.$i18n.locale];
  }

  get blockClasses(): string[] {
    return [
      contentBlockImageSizeModifiersMap[this.settings.imageSize],
      contentBlockTextHorizontalAlignmentModifiersMap[this.settings.textHorizontalAlignment],
    ];
  }

  get blockStyles(): Record<string, string> {
    return {
      '--overlay-opacity': this.settings.overlayOpacity.toString(),
    };
  }
}
